import { use, useState } from "react";
import VacancyCandidate from "./VacancyCandidate";
import CandidateDetailModal from "../Candidates/DetailModal";

export default function VacancyCandidates({ match, vancancyCandidates }) {
  const [currentCandidate, setCurrentCandidate] = useState(null);
  const [isCandidateDetailModalOpen, setIsCandidateDetailModalOpen] =
    useState(false);

  const openCandidateDetailModal = (candidate) => {
    setCurrentCandidate(candidate);
    setIsCandidateDetailModalOpen(true);
  };

  const closeCandidateDetailModal = () => {
    setCurrentCandidate(null);
    setIsCandidateDetailModalOpen(false);
  };

  if (vancancyCandidates.length === 0) {
    return (
      <div className="text-center text-gray-400 py-12 text-lg">
        暂无匹配结果
      </div>
    );
  }

  return (
    <>
      {vancancyCandidates.map((vacancyCandidate, index) => (
        <VacancyCandidate
          key={index}
          match={match}
          vacancyCandidate={vacancyCandidate}
          onOpen={openCandidateDetailModal}
        />
      ))}
      <CandidateDetailModal
        isOpen={isCandidateDetailModalOpen}
        onClose={closeCandidateDetailModal}
        candidate={currentCandidate}
      />
    </>
  );
}
